// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2z-3";
export var dialog = "_2z-0";
export var divClassnameSwatch = "_2z-8";
export var flexSwatch = "_2z-4";
export var header = "_2z-1";
export var styleAttributeSwatch = "_2z-7";
export var swatch = "_2z-2";
export var textHeaderSwatch = "_2z-5";
export var webSwatch = "_2z-6";